export default function EmptyState({ image, title, description, action, testid }) {
  return (
    <div
      className="bg-white border border-warm rounded-2xl shadow-card p-10 flex flex-col items-center text-center"
      data-testid={testid}
    >
      {image && (
        <div className="w-40 h-40 rounded-2xl overflow-hidden mb-6 border border-warm">
          <img src={image} alt="" className="w-full h-full object-cover" />
        </div>
      )}
      <h3 className="font-heading text-2xl font-semibold text-[#2B2D42] mb-2">
        {title}
      </h3>
      {description && (
        <p className="text-slate-muted max-w-md mb-6">{description}</p>
      )}
      {action}
    </div>
  );
}
